import axiosInstance from './axiosInstance';

// Pricing
export const getPricing = () => axiosInstance.get('/Resource/GetPricing');
export const createPricing = (data) => axiosInstance.post('/Resource/CreatePricing', data);
export const updatePricing = (data) => axiosInstance.put('/Resource/UpdatePricing', data);
export const deletePricing = (id) => axiosInstance.delete(`/Resource/DeletePricing?id=${id}`);

// Addons
export const getAddons = () => axiosInstance.get('/Resource/GetAddons');
export const createAddon = (data) => axiosInstance.post('/Resource/CreateAddon', data);
export const updateAddon = (data) => axiosInstance.put('/Resource/UpdateAddon', data);
export const deleteAddon = (id) => axiosInstance.delete(`/Resource/DeleteAddon?id=${id}`);

// Documents & Links
export const getDocuments = () => axiosInstance.get('/Resource/GetDocuments');
export const createDocument = (data) => axiosInstance.post('/Resource/CreateDocument', data);
export const uploadDocument = (formData) => axiosInstance.post('/Resource/UploadDocument', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateDocument = (data) => axiosInstance.put('/Resource/UpdateDocument', data);
export const deleteDocument = (id) => axiosInstance.delete(`/Resource/DeleteDocument?id=${id}`);

// Pricing History
export const getPricingHistories      = () => axiosInstance.get('/Resource/GetPricingHistories');
export const getPricingHistoryItems   = (historyId) => axiosInstance.get(`/Resource/GetPricingHistoryItems?historyId=${historyId}`);
export const createPricingHistory     = (data) => axiosInstance.post('/Resource/CreatePricingHistory', data);
export const updatePricingHistory     = (data) => axiosInstance.put('/Resource/UpdatePricingHistory', data);
export const deletePricingHistory     = (id) => axiosInstance.delete(`/Resource/DeletePricingHistory?id=${id}`);
export const createPricingHistoryItem = (data) => axiosInstance.post('/Resource/CreatePricingHistoryItem', data);
export const updatePricingHistoryItem = (data) => axiosInstance.put('/Resource/UpdatePricingHistoryItem', data);
export const deletePricingHistoryItem = (id) => axiosInstance.delete(`/Resource/DeletePricingHistoryItem?id=${id}`);
